/**
 * Helper class for executing AJAX calls.
 */
export class Ajax
{
    public static get(url:string, success?:(data:any) => void, error?:(code:number) => void):void
    {
        let xhttp = new XMLHttpRequest();
        
        xhttp.onreadystatechange = function()
        {
          if (this.readyState == 4 && this.status == 200 && success != null)
          {
              success(this.responseText);
          }
        };
        xhttp.open("GET", url, true);
        xhttp.send(); 
    }

    public static getJSON(url:string, success?:(data:any) => void, error?:(code:number) => void):void
    {
        this.get(url, (data) => { data = JSON.parse(data); if (success != null) success(data); }, error);
    }
}